// import polyfill first to ensure compatibility with older browsers
// used for Promise.allSettled which is used by vite chunking
// Chrome >= 58 for Android API 26
import 'core-js/actual/promise/all-settled';

import { ANDROID_STORE_URL, IOS_STORE_URL } from "./media.ts";
import { TRACK_APP_START, tracker } from "./timetracker.ts";

const TRACK_APP_INIT = "App Initialization";
tracker.time(TRACK_APP_START); // start an early timer
tracker.time(TRACK_APP_INIT);

/**
 * Handle raw links like a /install redirection before loading the full app.
 */
async function handleRawLinks(urlStr: string) {
  const url = new URL(urlStr);
  const path = url.pathname;

  // only handle /install route
  if (path.startsWith('/install')) {
    const userAgent = navigator.userAgent?.toLowerCase();
    if (userAgent.match(/(iphone|ipad)/)) {
      window.location.href = IOS_STORE_URL; // TODO IOS URL
    } else if (userAgent.match(/android/)) {
      window.location.href = ANDROID_STORE_URL;
    }
    return true;
  }
  return false;
}

// Immediately handle raw links before loading the full app
(async () => {
  // cold start
  const startUrl = window.location?.href;
  // install only url
  if (startUrl && await handleRawLinks(startUrl)) return;
  // fallback → load full app
  import('./app-ui.ts'); // Framework7 / Svelte bootstrap
  tracker.timeEnd(TRACK_APP_INIT, true);
})();
